import cardActivator from '@/api/human-resource/card-activator'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  employees: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EMPLOYEES(state, data) {
    state.employees = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
          status_id: attributes.status_id
        }
      },
      attributes
    )
    return cardActivator.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return cardActivator.store(data)
  },

  update(context, { id, ...data }) {
    return cardActivator.update(id, data)
  },

  async checkCurrentEmployeeCardStatus(context, data) {
    return await cardActivator.checkCurrentEmployeeCardStatus(data)
  },

  async getEmployee(context, attributes = {}) {
    let response = await cardActivator.getEmployee({
      params: attributes
    })
    context.commit('SET_EMPLOYEES', response.data)
  }
}
